"use client";
import { useSidebar } from "@/context/SidebarContext";

export default function SidebarWidget() {
  const { isMobileOpen, toggleMobileSidebar } = useSidebar();

  const handlePostJob = () => {
    if (isMobileOpen) toggleMobileSidebar();
    window.open('https://flcityjobs.com/post', '_blank', 'noopener,noreferrer');
  };

  return (
    <div
      className={`
        mx-auto mb-10 w-full max-w-60 rounded-2xl bg-gray-50 px-4 py-5 text-center dark:bg-white/[0.03]`}
    >
      <button
        onClick={handlePostJob}
        className="flex items-center justify-center p-3 font-medium text-white rounded-lg bg-brand-500 text-theme-sm hover:bg-brand-600 transition-colors duration-200 cursor-pointer w-full"
      >
        Post a Job
      </button>
    </div>
  );
}
